var map = {
	"./amplify-amazon-button_5.entry.js": [
		670,
		78
	],
	"./amplify-auth-container.entry.js": [
		671,
		79
	],
	"./amplify-auth-fields_9.entry.js": [
		672,
		80
	],
	"./amplify-authenticator.entry.js": [
		673,
		38
	],
	"./amplify-button_3.entry.js": [
		674,
		81
	],
	"./amplify-chatbot.entry.js": [
		675,
		37
	],
	"./amplify-checkbox.entry.js": [
		676,
		82
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		677,
		39
	],
	"./amplify-container.entry.js": [
		678,
		83
	],
	"./amplify-federated-buttons_2.entry.js": [
		679,
		84
	],
	"./amplify-federated-sign-in.entry.js": [
		680,
		85
	],
	"./amplify-form-field_4.entry.js": [
		681,
		86
	],
	"./amplify-greetings.entry.js": [
		682,
		87
	],
	"./amplify-icon-button.entry.js": [
		683,
		88
	],
	"./amplify-icon.entry.js": [
		684,
		40
	],
	"./amplify-link.entry.js": [
		685,
		89
	],
	"./amplify-nav_2.entry.js": [
		686,
		90
	],
	"./amplify-photo-picker.entry.js": [
		687,
		91
	],
	"./amplify-picker.entry.js": [
		688,
		92
	],
	"./amplify-radio-button_2.entry.js": [
		689,
		41
	],
	"./amplify-s3-album.entry.js": [
		690,
		42
	],
	"./amplify-s3-image-picker.entry.js": [
		691,
		43
	],
	"./amplify-s3-image.entry.js": [
		692,
		44
	],
	"./amplify-s3-text-picker.entry.js": [
		693,
		45
	],
	"./amplify-s3-text.entry.js": [
		694,
		46
	],
	"./amplify-select-mfa-type.entry.js": [
		695,
		93
	],
	"./amplify-sign-in-button.entry.js": [
		696,
		47
	],
	"./amplify-toast.entry.js": [
		697,
		94
	],
	"./amplify-tooltip.entry.js": [
		698,
		95
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 608;
module.exports = webpackAsyncContext;